import React from 'react'
import { Card } from 'goustouicomponents/dist/Card'
import { CTA } from 'goustouicomponents/dist/CTA'
import { Box, Heading2 } from '@gousto-internal/citrus-react'
import { externalGoustoPages } from '../../config/routes'
import css from './LoginPrompt.module.css'

const LoginPrompt = () => (
  <section>
    <Box className={css.heading} paddingBottom={2}>
      <Heading2 size={4}>Login for faster assistance</Heading2>
    </Box>
    <Card>
      <p>
        We&apos;re able to support you better on any issues with your order if you&apos;re
        logged in.
      </p>
      <a
        href={externalGoustoPages.login}
        data-tracking-action="help_centre_home_click_login"
      >
        <CTA
          isFullWidth
          size="small"
          onClick={() => {}}
        >
          Login
        </CTA>
      </a>
    </Card>
  </section>
)

export { LoginPrompt }
